import { Component, HostListener, OnInit, ViewChild } from "@angular/core";
import { LocalstorageService, UserService } from "../../../shared";
import { GMap } from "../bus-tracker-main-map/shared/gmap";
import { BTBusGetPersonPhotosRequest } from "./shared/BTBusGetPersonPhotosRequest";
import { DataService_BusTrackerGeoFenceHistory } from "./shared/data.service";
import { GeoFenceHistoryRequest } from "./shared/GeoFenceHistoryRequest";
import * as moment from "moment";

@Component({
	selector: "app-bus-tracker-geo-fence-history",
	templateUrl: "./bus-tracker-geo-fence-history.component.html",
	styleUrls: ["./bus-tracker-geo-fence-history.component.css"],
})
export class BusTrackerGeoFenceHistoryComponent implements OnInit {
	constructor(private userService: UserService, private localService: LocalstorageService, private busService: DataService_BusTrackerGeoFenceHistory) {}

	// ngOnInit(): void {
	//   this.user = this.userService.getCurrentUser();

	//   this.loadPreferences();
	// }

	ngOnInit(): void {}
	ngAfterViewInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadPreferences();
	}

	ngOnDestory() {
		this.UpdatePreferences();
	}

	@HostListener("window:keydown", ["$event"])
	LogKeys(e: KeyboardEvent) {
		// ESC or Delete = Pause
		if (e.keyCode === 27 || e.keyCode === 46) {
			this.StudentUnSpiderfy();
		}
	}

	///////////////////////////////////////////////////////////////////////////
	//#region Data
	///////////////////////////////////////////////////////////////////////////

	//////////////////////////////
	//#region Top Bar Options
	//////////////////////////////

	ShowNewPoints: any = true;
	ShowPreview: any = true;

	NewFenceColor: any = "#000";
	DefaultFenceColor: any = "#000";
	NewOpacity: any = 0.35;
	DefaultOpacity: any = 0.35;

	HeatMapOptionID: any = -1;
	lstHeatMapOption: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 0,
			Desc: "Buses",
		},
		{
			ID: -2,
			Desc: "Students",
		},
		{
			ID: 1,
			Desc: "Student ON",
		},
		{
			ID: 2,
			Desc: "Student OFF",
		},
	];

	lstBuses: any = [];

	ShowBusLocation: any = true;

	BusShowBusNbr: any = true;
	BusShowBusRouteDesc: any = false;
	BusShowBusRouteTypeDesc: any = false;
	BusShowCDate: any = true;
	BusShowSpeed: any = false;
	BusShowLatLong: any = false;
	BusShowDriver: any = false;
	BusTextColor: string = "#000000";
	DefaultBusTextColor: string = "#000000";

	// lstStudents: any = [];
	lstStudentsSwipeOn: any = [];
	lstStudentsSwipeOff: any = [];

	ShowStudentsSwipeOn: any = true;
	ShowStudentsSwipeOff: any = true;

	ShowStudentName: any = true;
	ShowStudentID: any = false;
	ShowStudentBus: any = false;
	ShowStudentScanTime: any = true;
	ShowScheduledRider: any = false;
	StudentTextColor: string = "#0000FF";
	DefaultStudentTextColor: string = "#0000FF";

	lstGeoFence: any = [];
	ShowGeoFences: any = false;
	HideInactiveGeoFences: any = true;

	StartDT: Date = new Date();
	EndDT: Date = new Date();
	SearchInside: boolean = true;

	ShowHeatMap: any = true;
	HideUnselected: any = false;
	lstSelectedBuses: any = [];
	BusesFromSelector: any = [];
	lstSelectedStudents: any = [];
	StudentsFromSelector: any = [];

	//#endregion
	//////////////////////////////

	//////////////////////////////
	//#region Map General
	//////////////////////////////

	ShowInfo: boolean = false;
	ShowMap: boolean = false;
	ShowSideBar: boolean = false;
	lstNewPoints: any[] = []; //For hiding new points
	overlays: any[] = [];
	options: any;
	MapPrefs: any;

	user: any;

	@ViewChild(GMap)
	mapRef: GMap;

	InitStylesAndListeners: any = false;

	RouteColorMaxSum: any = 384;
	lstRouteColors: string[] = [];

	errorMessage: any = "";

	heatmap: any;
	lstHeatMap: any = [];

	//#endregion
	//////////////////////////////

	//////////////////////////////
	//#region Loading
	//////////////////////////////

	Processing: boolean = false;
	PrefLoading: boolean = true;
	TopBarLoading: any = true;
	DataLoading: boolean = false;

	//#endregion
	//////////////////////////////

	//////////////////////////////
	//#region Spiderfy (for Students)
	//////////////////////////////

	Tolerance: any = 35;
	SpiderMaxLegs: any = 10; //10;
	SpiderLegLength: any = 0.01;
	ZoomCoefficient: any = 0.0000001; //0.1;
	lstSpiderOverlays: any = [];
	SpiderfyBusStudentRideTxnID = -1;
	lstOverlaps = [];

	//#endregion
	//////////////////////////////

	//#endregion
	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	//#region Load Data
	///////////////////////////////////////////////////////////////////////////

	loadPreferences() {
		this.PrefLoading = true;

		var result = this.busService.BusMapPreferenceSelect(this.user.personID);
		result.subscribe(
			(response) => {
				this.MapPrefs = response[0];

				this.options = {
					center: {
						lat: Number(this.MapPrefs.DefaultLat),
						lng: Number(this.MapPrefs.DefaultLong),
					},
					zoom: Number(this.MapPrefs.DefaultZoom),
				};

				this.ShowMap = true;

				this.PrefLoading = false;

				this.loadTopBarOptions();
			},
			(error) => {
				this.PrefLoading = false;
			}
		);
	}

	loadTopBarOptions() {
		this.TopBarLoading = true;

		var BT_GeoFence_History_Options = this.localService.getItem("BT_GeoFence_History_Options");

		if (BT_GeoFence_History_Options != undefined) {
			this.ShowNewPoints = BT_GeoFence_History_Options.ShowNewPoints == undefined ? true : BT_GeoFence_History_Options.ShowNewPoints;
			this.ShowPreview = BT_GeoFence_History_Options.ShowPreview == undefined ? true : BT_GeoFence_History_Options.ShowPreview;
			this.NewFenceColor = BT_GeoFence_History_Options.NewFenceColor == undefined ? true : BT_GeoFence_History_Options.NewFenceColor;
			this.NewOpacity = BT_GeoFence_History_Options.NewOpacity == undefined ? true : BT_GeoFence_History_Options.NewOpacity;
			this.StartDT = BT_GeoFence_History_Options.StartDT == undefined ? new Date() : new Date(BT_GeoFence_History_Options.StartDT);
			this.EndDT = BT_GeoFence_History_Options.EndDT == undefined ? new Date() : new Date(BT_GeoFence_History_Options.EndDT);
			this.SearchInside = BT_GeoFence_History_Options.SearchInside == undefined ? true : BT_GeoFence_History_Options.SearchInside;
			(this.HideUnselected = BT_GeoFence_History_Options.HideUnselected == undefined ? false : BT_GeoFence_History_Options.HideUnselected),
				(this.ShowHeatMap = BT_GeoFence_History_Options.ShowHeatMap == undefined ? true : BT_GeoFence_History_Options.ShowHeatMap),
				(this.HeatMapOptionID = BT_GeoFence_History_Options.HeatMapOptionID == undefined ? -1 : BT_GeoFence_History_Options.HeatMapOptionID),
				(this.ShowBusLocation = BT_GeoFence_History_Options.ShowBusLocation == undefined ? true : BT_GeoFence_History_Options.ShowBusLocation);
			this.BusShowBusNbr = BT_GeoFence_History_Options.BusShowBusNbr == undefined ? true : BT_GeoFence_History_Options.BusShowBusNbr;
			this.BusShowBusRouteDesc = BT_GeoFence_History_Options.BusShowBusRouteDesc == undefined ? true : BT_GeoFence_History_Options.BusShowBusRouteDesc;
			this.BusShowBusRouteTypeDesc =
				BT_GeoFence_History_Options.BusShowBusRouteTypeDesc == undefined ? true : BT_GeoFence_History_Options.BusShowBusRouteTypeDesc;
			this.BusShowCDate = BT_GeoFence_History_Options.BusShowCDate == undefined ? true : BT_GeoFence_History_Options.BusShowCDate;
			this.BusShowSpeed = BT_GeoFence_History_Options.BusShowSpeed == undefined ? true : BT_GeoFence_History_Options.BusShowSpeed;
			this.BusShowLatLong = BT_GeoFence_History_Options.BusShowLatLong == undefined ? true : BT_GeoFence_History_Options.BusShowLatLong;
			this.BusShowDriver = BT_GeoFence_History_Options.BusShowDriver == undefined ? true : BT_GeoFence_History_Options.BusShowDriver;
			this.BusTextColor = BT_GeoFence_History_Options.BusTextColor == undefined ? true : BT_GeoFence_History_Options.BusTextColor;

			this.ShowStudentsSwipeOn = BT_GeoFence_History_Options.ShowStudentsSwipeOn == undefined ? true : BT_GeoFence_History_Options.ShowStudentsSwipeOn;
			this.ShowStudentsSwipeOff = BT_GeoFence_History_Options.ShowStudentsSwipeOff == undefined ? true : BT_GeoFence_History_Options.ShowStudentsSwipeOff;
			this.ShowStudentName = BT_GeoFence_History_Options.ShowStudentName == undefined ? true : BT_GeoFence_History_Options.ShowStudentName;
			this.ShowStudentID = BT_GeoFence_History_Options.ShowStudentID == undefined ? true : BT_GeoFence_History_Options.ShowStudentID;
			this.ShowStudentBus = BT_GeoFence_History_Options.ShowStudentBus == undefined ? true : BT_GeoFence_History_Options.ShowStudentBus;
			this.ShowStudentScanTime = BT_GeoFence_History_Options.ShowStudentScanTime == undefined ? true : BT_GeoFence_History_Options.ShowStudentScanTime;
			this.ShowScheduledRider = BT_GeoFence_History_Options.ShowScheduledRider == undefined ? false : BT_GeoFence_History_Options.ShowScheduledRider;
			this.StudentTextColor = BT_GeoFence_History_Options.StudentTextColor == undefined ? true : BT_GeoFence_History_Options.StudentTextColor;

			this.ShowGeoFences = BT_GeoFence_History_Options.ShowGeoFences == undefined ? false : BT_GeoFence_History_Options.ShowGeoFences;
			this.HideInactiveGeoFences =
				BT_GeoFence_History_Options.HideInactiveGeoFences == undefined ? true : BT_GeoFence_History_Options.HideInactiveGeoFences;
		}

		this.TopBarLoading = false;

		this.loadGeoFences(); //Only load once per page load
	}

	loadGeoFences() {
		var result = this.busService.GeoFenceSelectList();
		result.subscribe(
			(response) => {
				this.lstGeoFence = response;
				this.DrawGeoFences();
				this.loadHeatMap(); //Only load once per page load
			},
			(error) => {}
		);
	}

	loadHeatMap() {
		var result = this.busService.GeoFenceHistoryHeatMapSelectList(this.user.userID);
		result.subscribe(
			(response) => {
				this.lstHeatMap = response;

				this.heatmap = new google.maps.visualization.HeatmapLayer({
					data: this.getPoints(),
					// maxIntensity: 1
				});

				if (this.ShowHeatMap == true) {
					this.heatmap.setMap(this.mapRef.map);
				}
			},
			(error) => {}
		);
	}

	getPoints() {
		var ans: google.maps.LatLng[] = [];

		for (var z = 0; z < this.lstHeatMap.length; z++) {
			var next = this.lstHeatMap[z];

			if (
				this.HeatMapOptionID == -1 || //All Points
				(this.HeatMapOptionID == -2 && (next.TypeID == 1 || next.TypeID == 2)) || //All Students
				next.TypeID == this.HeatMapOptionID //Specific Type
			) {
				ans = [...ans, new google.maps.LatLng(Number(next.Lat), Number(next.Long))];
			}
		}

		return ans;
	}

	UpdateMapStylesAndListeners() {
		//
		// Only Run 1 time
		//
		if (this.InitStylesAndListeners == true) {
			return;
		}

		this.InitStylesAndListeners = true;

		/////////////////////////////////////////////////////
		// Styling
		/////////////////////////////////////////////////////

		this.mapRef.map.data.setStyle(function (feature) {
			var Type = feature.getProperty("Type");

			var ParentPath: any = "assets/images/BusTrackerMap/BusIconsV4/";

			if (Type == "Bus") {
				let nextLabel: google.maps.MarkerLabel = null;

				var NextText: any = feature.getProperty("BusLabel");
				// var NextColor: any = "Black";
				var NextColor: any = feature.getProperty("BusTextColor");

				// if(feature.getProperty('HasAlert') == true || feature.getProperty('ShowSpeedWarning') == true){
				if (feature.getProperty("HasAlert") == true) {
					NextColor = "Red";
				}

				nextLabel = {
					text: NextText,
					color: NextColor,
					fontWeight: "Bold",
				};

				var iconPath: any = "";
				var Severity: any = Number(feature.getProperty("Severity"));
				var Selected: any = feature.getProperty("Selected");

				iconPath = ParentPath + "Bus_Default.png";

				if (Severity == 0) {
					if (Selected) {
						iconPath = ParentPath + "Bus_DefaultSelected.png";
					} else {
						iconPath = ParentPath + "Bus_Default.png";
					}
				} else if (Severity == 3) {
					if (Selected) {
						iconPath = ParentPath + "Bus_LowAlertSelected.png";
					} else {
						iconPath = ParentPath + "Bus_LowAlert.png";
					}
				} else if (Severity == 2) {
					if (Selected) {
						iconPath = ParentPath + "Bus_MediumAlertSelected.png";
					} else {
						iconPath = ParentPath + "Bus_MediumAlert.png";
					}
				} else if (Severity == 1) {
					if (Selected) {
						iconPath = ParentPath + "Bus_HighAlertSelected.png";
					} else {
						iconPath = ParentPath + "Bus_HighAlert.png";
					}
				}

				if (NextText != "") {
					return {
						icon: {
							url: iconPath,
							labelOrigin: {
								x: 25,
								y: 60,
							},
						},
						label: nextLabel,
						title: feature.getProperty("BusNbr"),
					};
				} else {
					return {
						icon: {
							url: iconPath,
							labelOrigin: {
								x: 25,
								y: 60,
							},
						},
						title: feature.getProperty("BusNbr"),
					};
				}
			} else if (Type == "Student") {
				var iconPath: any = "/assets/images/BusTrackerMap/student_icon.png";
				let nextLabel: google.maps.MarkerLabel = null;

				var NextText: any = feature.getProperty("StudentLabel");
				var NextColor: any = feature.getProperty("StudentTextColor");

				var EntryTypeID = feature.getProperty("EntryTypeID");
				var Selected = feature.getProperty("Selected");

				if (EntryTypeID == 1) {
					if (Selected) {
						iconPath = ParentPath + "StudentOnSelected.png";
					} else {
						iconPath = ParentPath + "StudentOn.png";
					}
				} else if (EntryTypeID == 2) {
					if (Selected) {
						iconPath = ParentPath + "StudentOffSelected.png";
					} else {
						iconPath = ParentPath + "StudentOff.png";
					}
				}

				// if(feature.getProperty("LastTransaction") == true){
				//   NextText += "*";
				// }

				nextLabel = {
					text: NextText,
					color: NextColor,
					fontWeight: "Bold",
				};

				if (NextText != "") {
					return {
						icon: {
							url: iconPath,
							labelOrigin: {
								x: 17.5,
								y: -10,
							},
						},
						label: nextLabel,
						title: feature.getProperty("StudentName"),
					};
				} else {
					return {
						icon: {
							url: iconPath,
							labelOrigin: {
								x: 17.5,
								y: -10,
							},
						},
						title: feature.getProperty("StudentName"),
					};
				}
			} else if (Type == "GeoFence") {
				let nextLabel: google.maps.MarkerLabel = null;

				var NextText: any = feature.getProperty("Label");

				nextLabel = {
					text: NextText,
					color: "Black", //NextColor,
					fontWeight: "Bold",
				};

				var NextStrokeColor: any = "Black";
				var NextStrokeWeight: any = 1;

				if (feature.getProperty("Selected") == true) {
					NextStrokeColor = "Blue";
					NextStrokeWeight = 4;
				}

				if (NextText != "") {
					return {
						label: nextLabel,
						title: feature.getProperty("GeoFenceID"),
						strokeOpacity: 0.5,
						strokeColor: NextStrokeColor,
						strokeWeight: NextStrokeWeight,
						fillColor: feature.getProperty("FillColor"),
						fillOpacity: feature.getProperty("AlphaChannel"),
					};
				} else {
					return {
						title: feature.getProperty("GeoFenceID"),
						strokeOpacity: 0.5,
						strokeColor: NextStrokeColor,
						strokeWeight: NextStrokeWeight,
						fillColor: feature.getProperty("FillColor"),
						fillOpacity: feature.getProperty("AlphaChannel"),
					};
				}
			} else if (Type == "KnownLocation") {
				let nextLabel: google.maps.MarkerLabel = null;

				var NextText: any = feature.getProperty("Label");
				var NextColor: any = feature.getProperty("TextColor");

				nextLabel = {
					text: NextText,
					color: NextColor,
					fontWeight: "Bold",
				};

				var iconPath: any = "";

				var Selected: any = feature.getProperty("Selected");
				if (Selected) {
					iconPath = ParentPath + "KnownLocation_Selected.png";
				} else {
					iconPath = ParentPath + "KnownLocation_Unselected.png";
				}

				if (NextText != "") {
					return {
						icon: {
							url: iconPath,
							labelOrigin: {
								x: 10,
								y: 30,
							},
							anchor: {
								x: 12.5,
								y: 12.5,
							},
						},
						label: nextLabel,
						title: feature.getProperty("BusNbr") + " " + feature.getProperty("c_dateDesc"),
					};
				} else {
					return {
						icon: {
							url: iconPath,
							labelOrigin: {
								x: 10,
								y: 30,
							},
							anchor: {
								x: 12.5,
								y: 12.5,
							},
						},
						title: feature.getProperty("BusNbr") + " " + feature.getProperty("c_dateDesc"),
					};
				}
			}
		});

		/////////////////////////////////////////////////////

		/////////////////////////////////////////////////////
		// Event Listeners
		/////////////////////////////////////////////////////

		this.mapRef.map.data.addListener("rightclick", (event) => {
			/////////////////////////////////////////////////////////////////////////////////////////////////////
			// Open Info Window
			/////////////////////////////////////////////////////////////////////////////////////////////////////

			let infoWindow: google.maps.InfoWindow = new google.maps.InfoWindow();

			var type: any = event.feature.getProperty("Type");

			var latLng: google.maps.LatLng;

			if (type == "Bus") {
				infoWindow.setContent(this.GetBusPopup(event.feature, infoWindow));
				latLng = new google.maps.LatLng({
					lat: event.feature.getProperty("Lat"),
					lng: event.feature.getProperty("Long"),
				});
			} else if (type == "Student") {
				infoWindow.setContent(this.GetStudentPopup(event.feature, infoWindow));

				//
				// If spiderfied, display window near new position
				//
				var Point: google.maps.Data.Point = event.feature.getGeometry();
				var latLng: google.maps.LatLng = Point.get();
			} else if (type == "GeoFence") {
				infoWindow.setContent(this.GetGeoFencePopup(event.feature));
				latLng = new google.maps.LatLng({
					lat: event.feature.getProperty("Lat"),
					lng: event.feature.getProperty("Long"),
				});
			} else if (type == "KnownLocation") {
				infoWindow.setContent(this.GetKnownLocationPopup(event.feature));
				latLng = new google.maps.LatLng({
					lat: event.feature.getProperty("Lat"),
					lng: event.feature.getProperty("Long"),
				});
			}

			infoWindow.setOptions({
				// position: { lat: event.feature.getProperty("Lat"), lng: event.feature.getProperty("Long") }
				position: latLng,
			});

			infoWindow.open(this.mapRef.map);

			/////////////////////////////////////////////////////////////////////////////////////////////////////
		});

		this.mapRef.map.data.addListener("click", (event) => {
			//
			// Check if student
			//
			if (event.feature.getProperty("Type") == "Student") {
				//
				// First Check if it is overlapping other students
				//

				var Overlap: any = false;
				for (var z = 0; z < this.lstOverlaps.length; z++) {
					var next = this.lstOverlaps[z];

					if (next.getProperty("BusStudentRideTxnID") == event.feature.getProperty("BusStudentRideTxnID")) {
						Overlap = true;
						break;
					}
				}

				//
				// If overlapping and not spiderfied already
				// then spiderfy
				//
				if (!Overlap && event.feature.getProperty("BusStudentRideTxnID") != this.SpiderfyBusStudentRideTxnID) {
					//
					// Unspiderfy existing web
					//
					if (Number(this.lstOverlaps.length) > 0) {
						this.StudentUnSpiderfy();
					}

					//
					// Update overlap list
					//
					this.SpiderfyUpdateOverlapList(event);

					//
					// If there are overlaps, spiderfy
					//
					if (this.lstOverlaps.length > 0) {
						this.StudentSpiderfy(event);
					}
					//
					// If normal point then select like normal
					//
					else {
						this.SelectStudent(event);
					}
				}
				//
				// Else select or deselect (Point is part of current spider web, either center or expanded point)
				//
				else {
					this.SelectStudent(event);
				}
			}
			//
			// Not student
			//
			else {
				//
				// Close spiderfy if opened
				//
				if (this.lstOverlaps.length > 0) {
					this.StudentUnSpiderfy();
				}

				//
				// Check if other item was clicked on
				//
				if (event.feature.getProperty("Type") == "Bus") {
					/////////////////////////////////////////////////////////////////////////////////////////////////////
					// Select or deselect Bus
					/////////////////////////////////////////////////////////////////////////////////////////////////////

					var tempSelected = event.feature.getProperty("Selected");

					var NewSelected = true;
					if (tempSelected == true) {
						NewSelected = false;
					}

					event.feature.setProperty("Selected", NewSelected);

					var BusID = event.feature.getProperty("BusID");

					if (NewSelected == true) {
						for (var z = 0; z < this.lstBuses.length; z++) {
							var next = this.lstBuses[z];

							if (next.BusID == BusID) {
								this.lstSelectedBuses = [...this.lstSelectedBuses, next];
								break;
							}
						}

						// this.mapRef.map.setCenter( { lat: event.feature.getProperty("Lat"), lng: event.feature.getProperty("Long") } );
					} else {
						this.lstSelectedBuses = this.lstSelectedBuses.filter((bus) => bus.BusID != BusID);
					}

					/////////////////////////////////////////////////////////////////////////////////////////////////////
				} else if (event.feature.getProperty("Type") == "KnownLocation") {
					var tempSelected = event.feature.getProperty("Selected");

					var NewSelected = true;
					if (tempSelected == true) {
						NewSelected = false;
					}

					event.feature.setProperty("Selected", NewSelected);
				} else if (event.feature.getProperty("Type") == "GeoFence") {
					//
					// Select border points
					//

					var geo = event.feature.getGeometry();

					geo.forEachLatLng((ll) => {
						// this.lstNewPoints.push(new google.maps.Marker({position: ll, draggable: true}));
						var event: any = { latLng: ll };

						this.CreateMarker(event);
					});

					this.ShowGeoFences = false;
					this.DeleteAllGeoFences();
				}
			}
		});

		/////////////////////////////////////////////////////
	}

	onLoad() {
		this.errorMessage = "";

		if (this.lstNewPoints.length < 3) {
			this.errorMessage = "Must draw at least 3 points to load data for";
			return;
		}

		this.DataLoading = true;

		let lstLats: string[] = [];
		let lstLongs: string[] = [];

		for (var z = 0; z < this.lstNewPoints.length; z++) {
			var next = this.lstNewPoints[z];

			if (next.latLngs == undefined) {
				lstLats = [...lstLats, next.position.lat()];
				lstLongs = [...lstLongs, next.position.lng()];
			}
		}

		//
		// Complete Polygon
		//
		lstLats = [...lstLats, lstLats[0]];
		lstLongs = [...lstLongs, lstLongs[0]];

		let parms: GeoFenceHistoryRequest = {
			UserID: this.user.userID,
			StartDT: moment(this.StartDT).format("MM/DD/YYYY HH:mm:00"),
			EndDT: moment(this.EndDT).format("MM/DD/YYYY HH:mm:00"),
			Inside: this.SearchInside,
			lstLat: lstLats,
			lstLong: lstLongs,
		};

		var result = this.busService.GeoFenceHistoryBusInfoGetList(parms);
		result.subscribe(
			(response: any) => {
				var AnyError: boolean = false;

				if (response != undefined) {
					if (response.lstBuses.length > 0 && response.lstBuses[0].ErrorMessage != "") {
						this.errorMessage = response.lstBuses[0].ErrorMessage;
						AnyError = true;
					} else if (response.lstStudentsSwipeOn.length > 0 && response.lstStudentsSwipeOn[0].ErrorMessage != "") {
						this.errorMessage = response.lstStudentsSwipeOn[0].ErrorMessage;
						AnyError = true;
					} else if (response.lstStudentsSwipeOff.length > 0 && response.lstStudentsSwipeOff[0].ErrorMessage != "") {
						this.errorMessage = response.lstStudentsSwipeOff[0].ErrorMessage;
						AnyError = true;
					}
				}

				if (AnyError == true) {
					this.lstBuses = [];
					this.lstStudentsSwipeOn = [];
					this.lstStudentsSwipeOff = [];
				} else {
					this.lstBuses = response.lstBuses;
					this.lstStudentsSwipeOn = response.lstStudentsSwipeOn;
					this.lstStudentsSwipeOff = response.lstStudentsSwipeOff;
				}

				this.UpdateMapStylesAndListeners();
				this.UpdateAll();

				this.DataLoading = false;
			},
			(error) => {
				this.DataLoading = false;
			}
		);
	}

	//#endregion
	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	//#region Buttons
	///////////////////////////////////////////////////////////////////////////

	onToggleInfo() {
		this.ShowInfo = !this.ShowInfo;
	}

	onSearch() {
		if (this.ShowMap == true) {
			this.ShowSideBar = !this.ShowSideBar;
		}
	}

	//#region Text Color Reset
	onResetBusLabelColor() {
		this.BusTextColor = this.DefaultBusTextColor;

		this.UpdateTextColor();
	}

	onResetStudentLabelColor() {
		this.StudentTextColor = this.DefaultStudentTextColor;

		this.UpdateTextColor();
	}
	//#endregion

	//#region Clear Points
	onClearAll() {
		this.onClearPoints();
		this.onClearData();
	}

	onClearPoints() {
		var newOverlays: any = [];

		for (var z = this.lstNewPoints.length - 1; z >= 0; z--) {
			var next = this.lstNewPoints[z];

			if (next.latLngs == undefined || (next.latLngs != undefined && next.fillOpacity != 0)) {
				this.lstNewPoints.splice(z, 1);
			} else {
				newOverlays = [...newOverlays, next];
			}
		}

		this.overlays = newOverlays;
		// this.lstNewPoints = [];
	}

	onClearData() {
		this.mapRef.map.data.forEach((element) => {
			this.mapRef.map.data.remove(element);
		});

		this.lstBuses = [];
		this.lstStudentsSwipeOn = [];
		this.lstStudentsSwipeOff = [];

		this.lstSelectedBuses = [];
		this.lstSelectedStudents = [];
		this.BusesFromSelector = [];
		this.StudentsFromSelector = [];

		for (var z = this.lstNewPoints.length - 1; z >= 0; z--) {
			var next = this.lstNewPoints[z];

			if (next.latLngs != undefined && next.fillOpacity == 0) {
				this.lstNewPoints.splice(z, 1);
			}
		}

		this.overlays = [];
		this.lstNewPoints.forEach((e) => {
			this.overlays = [...this.overlays, e];
		});

		this.DrawPreviewPolygon();

		// this.lstNewPoints = [];
	}
	//#endregion

	onDeselectAll() {
		this.lstSelectedBuses = [];
		this.BusesFromSelector = [];
		this.lstSelectedStudents = [];
		this.StudentsFromSelector = [];

		this.mapRef.map.data.forEach((element) => {
			try {
				if (element.getProperty("Selected") == true) {
					element.setProperty("Selected", false);
				}
			} catch (e) {
				e.toString();
			}
		});

		if (this.HideUnselected == true) {
			this.DeleteUnselected();
		}
	}

	UpdateAll() {
		//
		// Remove Points and polygon
		//
		this.overlays = [];

		//
		// Remove old points
		//
		this.mapRef.map.data.forEach((element) => {
			this.mapRef.map.data.remove(element);
		});

		//
		// Draw Clear Polygon
		//

		var lstLatLng: google.maps.LatLng[] = [];

		for (var z = 0; z < this.lstNewPoints.length; z++) {
			var next = this.lstNewPoints[z];

			if (next.latLngs == undefined) {
				lstLatLng = [...lstLatLng, new google.maps.LatLng(next.position.lat(), next.position.lng())];
			}
		}

		for (var z = this.lstNewPoints.length - 1; z >= 0; z--) {
			var next = this.lstNewPoints[z];

			if (next.latLngs != undefined) {
				this.lstNewPoints.splice(z, 1);
			}
		}

		var poly = new google.maps.Polygon({
			paths: [lstLatLng],
			strokeOpacity: 0.5,
			strokeWeight: 3,
			fillColor: this.NewFenceColor,
			fillOpacity: 0,
		});

		this.overlays.push(poly);
		this.lstNewPoints = [];

		//TEST
		this.lstNewPoints.push(poly);

		this.UpdateBuses();
		this.UpdateStudents();
	}

	UpdateBuses() {
		if (this.ShowBusLocation == false) {
			return;
		}

		//
		// Draw Buses
		//
		for (var z = 0; z < this.lstBuses.length; z++) {
			var next = this.lstBuses[z];

			this.DrawBus(next);
		}
	}

	DeleteAllBuses() {
		this.mapRef.map.data.forEach((element) => {
			try {
				if (element.getProperty("Type") == "KnownLocation") {
					this.mapRef.map.data.remove(element);
				}
			} catch (e) {
				e.toString();
			}
		});
	}

	DrawBus(BusInfo) {
		var ManuallySelected: boolean = false;
		var FromSelector: boolean = false;

		for (var i = 0; i < this.lstSelectedBuses.length; i++) {
			var nextSelectedBus = this.lstSelectedBuses[i];

			if (nextSelectedBus.BusID == BusInfo.BusID) {
				ManuallySelected = true;
				break;
			}
		}

		if (ManuallySelected == false) {
			for (var i = 0; i < this.BusesFromSelector.length; i++) {
				var nextSelectedBus = this.BusesFromSelector[i];

				if (nextSelectedBus == BusInfo.BusID) {
					FromSelector = true;
					break;
				}
			}
		}

		if (this.HideUnselected == true) {
			if (!ManuallySelected && !FromSelector) {
				return;
			}
		}

		let NextLabel: any = "";

		if (this.BusShowBusNbr == true) {
			NextLabel += BusInfo.BusNbr + " ";
		}
		if (this.BusShowBusRouteDesc == true) {
			NextLabel += BusInfo.BusRouteDesc + " ";
		}
		if (this.BusShowBusRouteTypeDesc == true) {
			NextLabel += BusInfo.BusRouteTypeDesc + " ";
		}
		if (this.BusShowCDate == true) {
			NextLabel += "(" + BusInfo.c_dateDesc + ") ";
		}
		if (this.BusShowSpeed == true) {
			NextLabel += "(" + BusInfo.SpeedMph + " mph) ";
		}
		if (this.BusShowLatLong == true) {
			NextLabel += "(" + BusInfo.Lat + ", " + BusInfo.Long + ") ";
		}
		if (this.BusShowDriver == true) {
			NextLabel += "(" + BusInfo.DriverName + ") ";
		}

		let KnownLocationLocation: google.maps.LatLng = new google.maps.LatLng(BusInfo.Lat, BusInfo.Long);
		let KnownLocationPoint: google.maps.Data.Point = new google.maps.Data.Point(KnownLocationLocation);
		let KnownLocationFeatureOptions: google.maps.Data.FeatureOptions = {
			geometry: KnownLocationPoint,
			properties: {
				Type: "KnownLocation",
				TextColor: this.BusTextColor,
				Label: NextLabel,
				BusLocationLogID: BusInfo.BusLocationLogID,
				BusID: BusInfo.BusID,
				BusNbr: BusInfo.BusNbr,
				BusDesc: BusInfo.BusDesc,
				DriverName: BusInfo.DriverName,
				BusRouteNbr: BusInfo.BusRouteNbr,
				BusRouteDesc: BusInfo.BusRouteDesc,
				BusRouteTypeDesc: BusInfo.BusRouteTypeDesc,
				SpeedMph: BusInfo.SpeedMph,
				c_date: BusInfo.c_date,
				c_dateDesc: BusInfo.c_dateDesc,
				Lat: Number(BusInfo.Lat),
				Long: Number(BusInfo.Long),
				Selected: ManuallySelected || FromSelector,
			},
		};

		let LocationFeature: google.maps.Data.Feature = new google.maps.Data.Feature(KnownLocationFeatureOptions);
		this.mapRef.map.data.add(LocationFeature);
	}

	UpdateStudents() {
		this.UpdateStudentSwipeOn();
		this.UpdateStudentSwipeOff();
	}

	UpdateStudentSwipeOn() {
		if (this.ShowStudentsSwipeOn == false) {
			return;
		}

		//
		// Draw Students
		//
		for (var z = 0; z < this.lstStudentsSwipeOn.length; z++) {
			var next = this.lstStudentsSwipeOn[z];

			this.DrawStudent(next);
		}
	}

	UpdateStudentSwipeOff() {
		if (this.ShowStudentsSwipeOff == false) {
			return;
		}

		//
		// Draw Students
		//
		for (var z = 0; z < this.lstStudentsSwipeOff.length; z++) {
			var next = this.lstStudentsSwipeOff[z];

			this.DrawStudent(next);
		}
	}

	DeleteAllStudents() {
		this.mapRef.map.data.forEach((element) => {
			try {
				if (element.getProperty("Type") == "Student") {
					this.mapRef.map.data.remove(element);
				}
			} catch (e) {
				e.toString();
			}
		});
	}

	DeleteStudentSwipeOn() {
		this.mapRef.map.data.forEach((element) => {
			try {
				if (element.getProperty("Type") == "Student") {
					if (element.getProperty("EntryTypeID") == 1) {
						this.mapRef.map.data.remove(element);
					}
				}
			} catch (e) {
				e.toString();
			}
		});
	}

	DeleteStudentSwipeOff() {
		this.mapRef.map.data.forEach((element) => {
			try {
				if (element.getProperty("Type") == "Student") {
					if (element.getProperty("EntryTypeID") == 2) {
						this.mapRef.map.data.remove(element);
					}
				}
			} catch (e) {
				e.toString();
			}
		});
	}

	DrawStudent(StudentInfo) {
		var ManuallySelected: any = false;
		var FromSelector: any = false;

		for (var z = 0; z < this.lstSelectedStudents.length; z++) {
			var next = this.lstSelectedStudents[z];

			if (next.Student_PersonID == StudentInfo.Student_PersonID) {
				ManuallySelected = true;
				break;
			}
		}

		if (ManuallySelected == false) {
			for (var z = 0; z < this.StudentsFromSelector.length; z++) {
				var next = this.StudentsFromSelector[z];

				if (StudentInfo.Student_PersonID == next) {
					FromSelector = true;
					break;
				}
			}

			//
			// Bus selected, also select its stops
			//
			if (FromSelector == false) {
				for (var z = 0; z < this.BusesFromSelector.length; z++) {
					var next = this.BusesFromSelector[z];

					if (StudentInfo.BusID == next) {
						FromSelector = true;
						break;
					}
				}
			}
		}

		if (this.HideUnselected == true) {
			if (!FromSelector && !ManuallySelected) {
				return;
			}
		}

		let NextLabel: any = "";

		if (this.ShowStudentName == true) {
			NextLabel += StudentInfo.StudentName + " ";
		}
		if (this.ShowStudentID == true) {
			NextLabel += "(" + StudentInfo.StudentID + ") ";
		}
		if (this.ShowStudentBus == true) {
			NextLabel += "(" + StudentInfo.BusNbr + ") ";
		}
		if (this.ShowStudentScanTime == true) {
			NextLabel += "(" + StudentInfo.c_dateDesc + ") ";
		}
		if (this.ShowScheduledRider == true) {
			NextLabel += "(" + StudentInfo.isScheduledRiderDesc + ") ";
		}

		let StudentLocation: google.maps.LatLng = new google.maps.LatLng(StudentInfo.Lat, StudentInfo.Long);
		let StudentPoint: google.maps.Data.Point = new google.maps.Data.Point(StudentLocation);
		let StudentFeatureOptions: google.maps.Data.FeatureOptions = {
			geometry: StudentPoint,
			properties: {
				Type: "Student",
				StudentTextColor: this.StudentTextColor,
				StudentLabel: NextLabel,
				BusStudentRideTxnID: StudentInfo.BusStudentRideTxnID,
				DriverName: StudentInfo.DriverName,
				Student_PersonID: StudentInfo.Student_PersonID,
				StudentID: StudentInfo.StudentID,
				StudentName: StudentInfo.StudentName,
				SchoolFullName: StudentInfo.SchoolFullName,
				AssignedRoute: StudentInfo.isScheduledRider,
				isScheduledRiderDesc: StudentInfo.isScheduledRiderDesc,
				BusRouteDesc: StudentInfo.BusRouteDesc,
				BusRouteTypeDesc: StudentInfo.BusRouteTypeDesc,
				BusID: StudentInfo.BusID,
				BusNbr: StudentInfo.BusNbr,
				BusDesc: StudentInfo.BusDesc,
				EntryTypeID: StudentInfo.EntryTypeID,
				EntryTypeDesc: StudentInfo.EntryTypeDesc,
				"c_date	": StudentInfo.c_date,
				c_dateDesc: StudentInfo.c_dateDesc,
				Lat: Number(StudentInfo.Lat),
				Long: Number(StudentInfo.Long),
				Selected: FromSelector || ManuallySelected,
				ScanTypeDesc: StudentInfo.ScanTypeDesc,
			},
		};

		let LocationFeature: google.maps.Data.Feature = new google.maps.Data.Feature(StudentFeatureOptions);
		this.mapRef.map.data.add(LocationFeature);
	}

	UpdateLabels() {
		this.mapRef.map.data.forEach((element) => {
			try {
				var NextLabel: any = "";

				if (element.getProperty("Type") == "KnownLocation") {
					if (this.BusShowBusNbr == true) {
						NextLabel += element.getProperty("BusNbr") + " ";
					}
					if (this.BusShowBusRouteDesc == true) {
						NextLabel += "(" + element.getProperty("BusRouteDesc") + ") ";
					}
					if (this.BusShowBusRouteTypeDesc == true) {
						NextLabel += "(" + element.getProperty("BusRouteTypeDesc") + ") ";
					}
					if (this.BusShowCDate == true) {
						NextLabel += "(" + element.getProperty("c_dateDesc") + ") ";
					}
					if (this.BusShowSpeed == true) {
						NextLabel += "(" + element.getProperty("SpeedMph") + " mph) ";
					}
					if (this.BusShowLatLong == true) {
						NextLabel += "(" + element.getProperty("Lat").toString() + ", " + element.getProperty("Long").toString() + ") ";
					}
					if (this.BusShowDriver == true) {
						NextLabel += "(" + element.getProperty("DriverName") + ") ";
					}

					element.setProperty("Label", NextLabel.toString());
				} else if (element.getProperty("Type") == "Student") {
					if (this.ShowStudentName == true) {
						NextLabel += element.getProperty("StudentName") + " ";
					}
					if (this.ShowStudentID == true) {
						NextLabel += "(" + element.getProperty("StudentID") + ") ";
					}
					if (this.ShowStudentBus == true) {
						NextLabel += "(" + element.getProperty("BusNbr") + ") ";
					}
					if (this.ShowStudentScanTime == true) {
						NextLabel += "(" + element.getProperty("c_dateDesc") + ") ";
					}
					if (this.ShowScheduledRider == true) {
						NextLabel += "(" + element.getProperty("isScheduledRiderDesc") + ") ";
					}

					element.setProperty("StudentLabel", NextLabel);
				}
			} catch (e) {
				e.toString();
			}
		});
	}

	UpdateTextColor() {
		this.mapRef.map.data.forEach((element) => {
			try {
				if (element.getProperty("Type") == "KnownLocation") {
					element.setProperty("TextColor", this.BusTextColor);
				} else if (element.getProperty("Type") == "Student") {
					element.setProperty("StudentTextColor", this.StudentTextColor);
				}
			} catch (e) {
				e.toString();
			}
		});
	}

	UpdateNewPoints() {
		//
		// Delete New Points if they exist
		//
		if (this.ShowNewPoints == false) {
			for (var z = this.overlays.length - 1; z >= 0; z--) {
				var next = this.overlays[z];

				if (next.latLngs == undefined) {
					this.overlays.splice(z, 1);
				}
			}
		}

		//
		// Else Draw them if they don't exist
		//
		else {
			this.lstNewPoints.forEach((e) => {
				this.overlays = [...this.overlays, e];
			});
		}
	}

	UpdatePreview() {
		//
		// Delete Preview Polygon if it exists
		//
		if (this.ShowPreview == false) {
			for (var z = this.overlays.length - 1; z >= 0; z--) {
				var next = this.overlays[z];

				// Don't Delete Previous Search Polygon
				if (next.latLngs != undefined && next.fillOpacity != 0) {
					this.overlays.splice(z, 1);
				}
			}
		}

		//
		// Else Draw the polygon if it doesn't exist
		//
		else {
			this.DrawPreviewPolygon();
		}
	}

	DeleteAllGeoFences() {
		this.mapRef.map.data.forEach((element) => {
			try {
				if (element.getProperty("Type") == "GeoFence") {
					this.mapRef.map.data.remove(element);
				}
			} catch (e) {
				e.toString();
			}
		});
	}

	DeleteInactiveGeoFences() {
		this.mapRef.map.data.forEach((element) => {
			try {
				if (element.getProperty("Type") == "GeoFence") {
					if (element.getProperty("Active") == false) {
						this.mapRef.map.data.remove(element);
					}
				}
			} catch (e) {
				e.toString();
			}
		});
	}

	DrawGeoFences() {
		this.UpdateMapStylesAndListeners();

		if (this.ShowGeoFences == false) {
			return;
		}
		for (var i = 0; i < this.lstGeoFence.length; i++) {
			var GeoFenceInfo = this.lstGeoFence[i];

			//
			// Check Active
			//
			if (GeoFenceInfo.Active == true || this.HideInactiveGeoFences == false) {
				//
				// Check if the fence already exists
				//
				var Exists: any = false;
				this.mapRef.map.data.forEach((element) => {
					try {
						if (element.getProperty("Type") == "GeoFence" && element.getProperty("GeoFenceID") == GeoFenceInfo.GeoFenceID) {
							Exists = true;
						}
					} catch (e) {
						e.toString();
					}
				});

				if (!Exists) {
					var lstLatLong: google.maps.LatLng[] = [];

					for (var z = 0; z < GeoFenceInfo.lstPoints.length; z++) {
						var next = GeoFenceInfo.lstPoints[z];

						lstLatLong = [
							...lstLatLong,
							new google.maps.LatLng({
								lat: next.Lat,
								lng: next.Long,
							}),
						];
					}

					let FencePolygon: google.maps.Data.Polygon = new google.maps.Data.Polygon([lstLatLong]);

					let FenceFeatureOptions: google.maps.Data.FeatureOptions = {
						geometry: FencePolygon,
						properties: {
							Type: "GeoFence",
							GeoFenceID: GeoFenceInfo.GeoFenceID,
							GeoFenceDesc: GeoFenceInfo.GeoFenceDesc,
							BusDesc: GeoFenceInfo.BusDesc,
							FillColor: GeoFenceInfo.FillColor,
							AlphaChannel: GeoFenceInfo.AlphaChannel,
							BusID: GeoFenceInfo.BusID,
							GeofenceTriggerTypeID: GeoFenceInfo.GeofenceTriggerTypeID,
							GeofenceTriggerTypeCD: GeoFenceInfo.GeofenceTriggerTypeCD,
							GeofenceTriggerTypeDesc: GeoFenceInfo.GeofenceTriggerTypeDesc,
							Severity: GeoFenceInfo.Severity,
							SeverityDesc: GeoFenceInfo.SeverityDesc,
							AlertComments: GeoFenceInfo.AlertComments,
							Active: GeoFenceInfo.Active,
							ActiveDesc: GeoFenceInfo.ActiveDesc,
							Lat: GeoFenceInfo.MidPointLat,
							Long: GeoFenceInfo.MidPointLong,
							lstPoints: GeoFenceInfo.lstPoints,
							Selected: false,
						},
					};

					let FenceFeature: google.maps.Data.Feature = new google.maps.Data.Feature(FenceFeatureOptions);
					this.mapRef.map.data.add(FenceFeature);
				}
			}
		}
	}

	//#endregion
	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	//#region Events
	///////////////////////////////////////////////////////////////////////////

	//////////////////////////////
	//#region Top Bar
	//////////////////////////////

	onStartDTChange(val) {
		this.StartDT = val;

		this.UpdatePreferences();
	}

	onEndDTChange(val) {
		this.EndDT = val;

		this.UpdatePreferences();
	}

	onShowNewPointsChange(val) {
		this.ShowNewPoints = val;

		this.UpdateNewPoints();
		this.UpdatePreferences();
	}

	onShowPreviewChange(val) {
		this.ShowPreview = val;

		this.UpdatePreview();
		this.UpdatePreferences();
	}

	onHideUnselectedChange(val) {
		this.HideUnselected = val;

		if (this.HideUnselected == true) {
			this.DeleteUnselected();
		} else {
			this.RedrawSelected();
		}

		this.UpdatePreferences();
	}

	onShowHeatMapChange(val) {
		this.ShowHeatMap = val;

		if (this.ShowHeatMap == true) {
			this.heatmap.setMap(this.mapRef.map);
		} else {
			this.heatmap.setMap(null);
		}

		this.UpdatePreferences();
	}

	onHeatMapOptionIDChange(val) {
		this.HeatMapOptionID = val;

		this.heatmap.setData(this.getPoints());

		this.UpdatePreferences();
	}

	onShowGeoFencesChange(val) {
		this.ShowGeoFences = val;

		if (this.ShowGeoFences == true) {
			this.DrawGeoFences();
		} else {
			this.DeleteAllGeoFences();
		}

		this.UpdatePreferences();
	}

	onHideInactiveGeoFencesChange(val) {
		this.HideInactiveGeoFences = val;

		if (this.HideInactiveGeoFences == true) {
			this.DeleteInactiveGeoFences();
		} else {
			this.DrawGeoFences();
		}

		this.UpdatePreferences();
	}

	//
	// Overlays
	//

	onShowBusLocationChange(val) {
		this.ShowBusLocation = val;

		if (this.ShowBusLocation == true) {
			this.UpdateBuses();
		} else {
			this.DeleteAllBuses();
		}

		this.UpdatePreferences();
	}

	onShowStudentsSwipeOnChange(val) {
		this.ShowStudentsSwipeOn = val;

		if (this.ShowStudentsSwipeOn == true) {
			this.UpdateStudentSwipeOn();
		} else {
			this.DeleteStudentSwipeOn();
		}

		this.UpdatePreferences();
	}

	onShowStudentsSwipeOffChange(val) {
		this.ShowStudentsSwipeOff = val;

		if (this.ShowStudentsSwipeOn == true) {
			this.UpdateStudentSwipeOff();
		} else {
			this.DeleteStudentSwipeOff();
		}

		this.UpdatePreferences();
	}

	//
	// Labels
	//

	onBusShowBusNbrChange(val) {
		this.BusShowBusNbr = val;

		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onBusShowBusRouteDescChange(val) {
		this.BusShowBusRouteDesc = val;

		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onBusShowBusRouteTypeDescChange(val) {
		this.BusShowBusRouteTypeDesc = val;

		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onBusShowCDateChange(val) {
		this.BusShowCDate = val;

		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onBusShowSpeedChange(val) {
		this.BusShowSpeed = val;

		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onBusShowLatLongChange(val) {
		this.BusShowLatLong = val;

		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onBusShowDriverChange(val) {
		this.BusShowDriver = val;

		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onShowStudentNameChange(val) {
		this.ShowStudentName = val;

		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onShowStudentIDChange(val) {
		this.ShowStudentID = val;

		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onShowStudentBusChange(val) {
		this.ShowStudentBus = val;

		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onShowStudentScanTimeChange(val) {
		this.ShowStudentScanTime = val;

		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onShowScheduledRiderChange(val) {
		this.ShowScheduledRider = val;

		this.UpdateLabels();
		this.UpdatePreferences();
	}

	//
	// Colors
	//
	onBusTextColorChange(val) {
		this.BusTextColor = val;

		this.UpdateTextColor();
	}

	onStudentTextColorChange(val) {
		this.StudentTextColor = val;

		this.UpdateTextColor();
	}

	//#endregion
	//////////////////////////////

	//////////////////////////////
	//#region Selector
	//////////////////////////////

	onSelectBusesOnMap(val) {
		this.BusesFromSelector = val.Buses;
		this.StudentsFromSelector = val.Students;

		if (this.HideUnselected == true) {
			this.RedrawSelected();
		} else {
			this.UpdateSelected();
		}
	}

	RedrawSelected() {
		//
		// Delete Unselected values
		//
		this.mapRef.map.data.forEach((element) => {
			try {
				var ManuallySelected: boolean = false;
				var FromSelector: boolean = false;

				if (element.getProperty("Type") == "KnownLocation") {
					for (var i = 0; i < this.lstSelectedBuses.length; i++) {
						var nextSelectedBus = this.lstSelectedBuses[i];

						if (nextSelectedBus.BusID == element.getProperty("BusID")) {
							ManuallySelected = true;
							break;
						}
					}

					if (ManuallySelected == false) {
						for (var i = 0; i < this.BusesFromSelector.length; i++) {
							var nextSelectedBus = this.BusesFromSelector[i];

							if (nextSelectedBus == element.getProperty("BusID")) {
								FromSelector = true;
								break;
							}
						}
					}

					element.setProperty("Selected", ManuallySelected || FromSelector);
					if (!ManuallySelected && !FromSelector) {
						this.mapRef.map.data.remove(element);
					}
				} else if (element.getProperty("Type") == "Student") {
					for (var z = 0; z < this.lstSelectedStudents.length; z++) {
						var next = this.lstSelectedStudents[z];

						if (next.Student_PersonID == element.getProperty("Student_PersonID")) {
							ManuallySelected = true;
							break;
						}
					}

					if (ManuallySelected == false) {
						for (var z = 0; z < this.StudentsFromSelector.length; z++) {
							var next = this.StudentsFromSelector[z];

							if (element.getProperty("Student_PersonID") == next) {
								FromSelector = true;
								break;
							}
						}

						//
						// Bus selected, also select its stops
						//
						if (FromSelector == false) {
							for (var z = 0; z < this.BusesFromSelector.length; z++) {
								var next = this.BusesFromSelector[z];

								if (element.getProperty("BusID") == next) {
									FromSelector = true;
									break;
								}
							}
						}
					}

					element.setProperty("Selected", ManuallySelected || FromSelector);
					if (!ManuallySelected && !FromSelector) {
						this.mapRef.map.data.remove(element);
					}
				}
			} catch (e) {
				e.toString();
			}
		});

		//
		// Draw Newly Selected Values
		//

		var lstExistingBusTxnIDs: any = []; //BusLocationLogID
		var lstExistingStudentTxnIDs: any = []; //BusStudentRideTxnID

		//
		// Get list of existing Buses and Students
		//
		this.mapRef.map.data.forEach((element) => {
			try {
				if (element.getProperty("Type") == "KnownLocation") {
					lstExistingBusTxnIDs = [...lstExistingBusTxnIDs, element.getProperty("BusLocationLogID")];
				}
				if (element.getProperty("Type") == "Student") {
					lstExistingStudentTxnIDs = [...lstExistingStudentTxnIDs, element.getProperty("BusStudentRideTxnID")];
				}
			} catch (e) {
				e.toString();
			}
		});

		if (this.ShowBusLocation == true) {
			for (var z = 0; z < this.lstBuses.length; z++) {
				var next = this.lstBuses[z];

				// Check Exists
				var Exists = false;
				for (var x = 0; x < lstExistingBusTxnIDs.length; x++) {
					var BusLocationLogID = lstExistingBusTxnIDs[x];

					if (BusLocationLogID == next.BusLocationLogID) {
						Exists = true;
						break;
					}
				}

				if (!Exists) {
					this.DrawBus(next);
				}
			}
		}

		if (this.ShowStudentsSwipeOn == true) {
			for (var z = 0; z < this.lstStudentsSwipeOn.length; z++) {
				var next = this.lstStudentsSwipeOn[z];

				// Check Exists
				var Exists = false;
				for (var x = 0; x < lstExistingStudentTxnIDs.length; x++) {
					var BusStudentRideTxnID = lstExistingStudentTxnIDs[z];

					if (BusStudentRideTxnID == next.BusStudentRideTxnID) {
						Exists = true;
						break;
					}
				}

				// Doesn't exist, check if it should
				if (!Exists) {
					this.DrawStudent(next);
				}
			}
		}

		if (this.ShowStudentsSwipeOff == true) {
			for (var z = 0; z < this.lstStudentsSwipeOff.length; z++) {
				var next = this.lstStudentsSwipeOff[z];

				// Check Exists
				var Exists = false;
				for (var x = 0; x < lstExistingStudentTxnIDs.length; x++) {
					var BusStudentRideTxnID = lstExistingStudentTxnIDs[x];

					if (BusStudentRideTxnID == next.BusStudentRideTxnID) {
						Exists = true;
						break;
					}
				}

				// Doesn't exist, check if it should
				if (!Exists) {
					this.DrawStudent(next);
				}
			}
		}
	}

	UpdateSelected() {
		//
		// Update Buses and Students
		//
		this.mapRef.map.data.forEach((element) => {
			try {
				var ManuallySelected: boolean = false;
				var FromSelector: boolean = false;

				if (element.getProperty("Type") == "KnownLocation") {
					for (var i = 0; i < this.lstSelectedBuses.length; i++) {
						var nextSelectedBus = this.lstSelectedBuses[i];

						if (nextSelectedBus.BusID == element.getProperty("BusID")) {
							ManuallySelected = true;
							break;
						}
					}

					if (ManuallySelected == false) {
						for (var i = 0; i < this.BusesFromSelector.length; i++) {
							var nextSelectedBus = this.BusesFromSelector[i];

							if (nextSelectedBus == element.getProperty("BusID")) {
								FromSelector = true;
								break;
							}
						}
					}

					element.setProperty("Selected", ManuallySelected || FromSelector);
				} else if (element.getProperty("Type") == "Student") {
					for (var z = 0; z < this.lstSelectedStudents.length; z++) {
						var next = this.lstSelectedStudents[z];

						if (next.Student_PersonID == element.getProperty("Student_PersonID")) {
							ManuallySelected = true;
							break;
						}
					}

					if (ManuallySelected == false) {
						for (var z = 0; z < this.StudentsFromSelector.length; z++) {
							var next = this.StudentsFromSelector[z];

							if (element.getProperty("Student_PersonID") == next) {
								FromSelector = true;
								break;
							}
						}

						//
						// Bus selected, also select its stops
						//
						if (FromSelector == false) {
							for (var z = 0; z < this.BusesFromSelector.length; z++) {
								var next = this.BusesFromSelector[z];

								if (element.getProperty("BusID") == next) {
									FromSelector = true;
									break;
								}
							}
						}
					}

					element.setProperty("Selected", ManuallySelected || FromSelector);
				}
			} catch (e) {
				e.toString();
			}
		});
	}

	DeleteUnselected() {
		this.mapRef.map.data.forEach((element) => {
			try {
				if ((element.getProperty("Type") == "KnownLocation" || element.getProperty("Type") == "Student") && element.getProperty("Selected") == false) {
					this.mapRef.map.data.remove(element);
				}
			} catch (e) {
				e.toString();
			}
		});
	}

	//#endregion
	//////////////////////////////

	//////////////////////////////
	//#region Drawing Overlays
	//////////////////////////////

	handleMapClick(val) {
		if (this.IsLoading() == true) {
			return;
		} else {
			this.CreateMarker(val);
		}
	}

	CreateMarker(clickEvent) {
		this.overlays = [];
		this.StudentUnSpiderfy(); ///////////////

		this.lstNewPoints.push(
			new google.maps.Marker({
				position: clickEvent.latLng,
				draggable: true,
			})
		);

		if (this.ShowNewPoints == true) {
			this.lstNewPoints.forEach((e) => {
				this.overlays = [...this.overlays, e];
			});
		}

		if (this.ShowPreview == true && this.lstNewPoints.length >= 3) {
			this.DrawPreviewPolygon();
		}
	}

	DrawPreviewPolygon() {
		//
		// Create Path from overlays
		// NOTE: Overlays array only has NEW points
		// Existing data is only on data layer
		//
		var lstLatLng: google.maps.LatLng[] = [];

		for (var z = 0; z < this.lstNewPoints.length; z++) {
			var next = this.lstNewPoints[z];

			if (next.latLngs == undefined) {
				lstLatLng = [...lstLatLng, new google.maps.LatLng(next.position.lat(), next.position.lng())];
			}
		}

		//
		// Add Polygon
		//
		var poly = new google.maps.Polygon({
			paths: [lstLatLng],
			strokeOpacity: 0.5,
			strokeWeight: 1,
			fillColor: this.NewFenceColor,
			fillOpacity: this.NewOpacity,
		});

		this.overlays.push(poly);
	}

	handleOverlayClick(val) {
		this.RemoveMarker(val);
	}

	RemoveMarker(clickEvent) {
		for (var z = 0; z < this.lstNewPoints.length; z++) {
			var next = this.lstNewPoints[z];

			if (next == clickEvent.overlay) {
				this.lstNewPoints.splice(z, 1);
				break;
			}
		}

		this.overlays = [];

		if (this.ShowNewPoints == true) {
			this.lstNewPoints.forEach((e) => {
				this.overlays = [...this.overlays, e];
			});
		}
		if (this.ShowPreview == true && this.lstNewPoints.length >= 3) {
			this.DrawPreviewPolygon();
		}
	}

	onOverlayDragEnd(val) {
		this.overlays = [];

		if (this.ShowNewPoints == true) {
			this.lstNewPoints.forEach((e) => {
				this.overlays = [...this.overlays, e];
			});
		}
		if (this.ShowPreview == true && this.lstNewPoints.length >= 3) {
			this.DrawPreviewPolygon();
		}
	}

	//#endregion
	//////////////////////////////

	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	//#region Helpers
	///////////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.PrefLoading == true || this.TopBarLoading == true || this.DataLoading == true;
	}

	UpdatePreferences() {
		let BT_GeoFence_History_Options: any = {
			ShowNewPoints: this.ShowNewPoints,
			ShowPreview: this.ShowPreview,
			NewFenceColor: this.NewFenceColor,
			NewOpacity: this.NewOpacity,
			StartDT: this.StartDT,
			EndDT: this.EndDT,
			SearchInside: this.SearchInside,
			HideUnselected: this.HideUnselected,
			ShowHeatMap: this.ShowHeatMap,
			HeatMapOptionID: this.HeatMapOptionID,

			ShowBusLocation: this.ShowBusLocation,
			BusShowBusNbr: this.BusShowBusNbr,
			BusShowBusRouteDesc: this.BusShowBusRouteDesc,
			BusShowBusRouteTypeDesc: this.BusShowBusRouteTypeDesc,
			BusShowCDate: this.BusShowCDate,
			BusShowSpeed: this.BusShowSpeed,
			BusShowLatLong: this.BusShowLatLong,
			BusShowDriver: this.BusShowDriver,
			BusTextColor: this.BusTextColor,

			ShowStudentsSwipeOn: this.ShowStudentsSwipeOn,
			ShowStudentsSwipeOff: this.ShowStudentsSwipeOff,
			ShowStudentName: this.ShowStudentName,
			ShowStudentID: this.ShowStudentID,
			ShowStudentBus: this.ShowStudentBus,
			ShowStudentScanTime: this.ShowStudentScanTime,
			ShowScheduledRider: this.ShowScheduledRider,
			StudentTextColor: this.StudentTextColor,

			ShowGeoFences: this.ShowGeoFences,
			HideInactiveGeoFences: this.HideInactiveGeoFences,
		};

		this.localService.setItem("BT_GeoFence_History_Options", BT_GeoFence_History_Options);
	}

	//#region Popups

	GetBusPopup(BusFeature, infoWindow) {
		//Start loading photo and update when it's done
		this.LoadBusStudentPhotos(BusFeature, infoWindow);

		//Return popup with loading message
		return this.BusStudentListImageLoading(BusFeature);
	}

	LoadBusStudentPhotos(BusFeature, infoWindow) {
		var lstPIDs: number[] = [];

		var lstStudents = BusFeature.getProperty("lstStudentsOnBus");

		for (var z = 0; z < lstStudents.length; z++) {
			var next = lstStudents[z];

			lstPIDs = [...lstPIDs, next.PersonID];
		}

		var parms: BTBusGetPersonPhotosRequest = {
			lstPersonIDs: lstPIDs,
		};

		var result = this.busService.BusGetPersonPhotos(parms);
		result.subscribe(
			(response) => {
				//
				// Update window when the person images have loaded
				//
				infoWindow.setContent(this.BusStudentList(response, BusFeature));
			},
			(error) => {}
		);
	}

	GetBusPopupMain(BusFeature) {
		var htmlText: any = "";

		//
		// Main Info
		//
		htmlText +=
			`
      <div style="display: grid; grid-template-columns: auto auto; grid-column-gap: 15px; grid-row-gap: 15px; padding: 15px; border: 2px solid black; border-radius: 15px; align-items: center;">
        
        <h4 style="grid-column: 1 / 3; text-align: center; margin-top: -5px; margin-bottom: -5px;">Bus:</h4>
    
        <label style="margin: 0px;">Bus Number:</label>
        <p style="margin: 0px; color: blue;">` +
			BusFeature.getProperty("BusNbr") +
			`</p>

        <label style="margin: 0px;">Bus Description:</label>
        <p style="margin: 0px; color: blue;">` +
			BusFeature.getProperty("BusDesc") +
			`</p>

        <label style="margin: 0px;">Driver:</label>
        <p style="margin: 0px; color: blue;">` +
			BusFeature.getProperty("DriverName") +
			`</p>

        <label style="margin: 0px;">Current Route:</label>
        <p style="margin: 0px; color: blue;">` +
			BusFeature.getProperty("BusRouteDesc") +
			`</p>

        <label style="margin: 0px;">Current Route Type:</label>
        <p style="margin: 0px; color: blue;">` +
			BusFeature.getProperty("BusRouteTypeDesc") +
			`</p>`;

		if (BusFeature.getProperty("Approx") == false) {
			htmlText +=
				`<label style="margin: 0px;">Latitude:</label>
        <p style="margin: 0px; color: blue;">` +
				BusFeature.getProperty("Lat") +
				`</p>

        <label style="margin: 0px;">Longitude:</label>
        <p style="margin: 0px; color: blue;">` +
				BusFeature.getProperty("Long") +
				`</p>`;
		} else {
			htmlText +=
				`<label style="margin: 0px;">Approx. Latitude:</label>
      <p style="margin: 0px; color: blue;">` +
				BusFeature.getProperty("Lat") +
				`</p>

      <label style="margin: 0px;">Approx. Longitude:</label>
      <p style="margin: 0px; color: blue;">` +
				BusFeature.getProperty("Long") +
				`</p>`;
		}

		if (BusFeature.getProperty("HasAlert") == true) {
			htmlText +=
				`
        <label style="margin: 0px;">Current Alert:</label>
        <p style="margin: 0px; color: Red;">` +
				BusFeature.getProperty("AlertDesc") +
				`</p>
      `;
		}

		htmlText +=
			`
      <label style="margin: 0px;">Student Count:</label>
      <p style="margin: 0px; color: blue;">` +
			BusFeature.getProperty("StudentCount") +
			`</p>

      </div>
    `;

		return htmlText;
	}

	//
	// Student list while the images are still loading
	//
	BusStudentListImageLoading(BusFeature) {
		var htmlText: any = "";

		//
		// Get main body
		//
		htmlText = this.GetBusPopupMain(BusFeature);

		//
		// List of Students
		//
		if (BusFeature.getProperty("StudentCount") > 0) {
			htmlText += `
        <style>
          table {
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
          }

          td, th {
            border: 1px solid #dddddd;
            text-align: left;
            padding: 8px;
          }

          tr:nth-child(even) {
            background-color: #dddddd;
          }
        </style>

        <div style="margin-top: 15px; padding: 15px; border: 2px solid black; border-radius: 15px; text-align: center;">
          <label>Students on Bus:</label>
          <table>
            <tr>
              <th>Photo</th>
              <th>Student ID</th>
              <th>Name</th>
            </tr>`;

			//
			// Add a row for each student in the list
			//
			var lstStudents = BusFeature.getProperty("lstStudentsOnBus");
			for (var z = 0; z < lstStudents.length; z++) {
				var next = lstStudents[z];

				htmlText +=
					`
          <tr` +
					(next.AssignedRoute == false ? ` style="color: Red;"` : ``) +
					`>
            <td>...Image Loading</td>
            <td>` +
					next.StudentID +
					`</td>
            <td>` +
					next.StudentName +
					(next.AssignedRoute == false ? ` <span style="color: Red;">*</span>` : ``) +
					`</td>
          </tr>
        `;
			}

			htmlText += `
          </table>
        </div>
      `;
		}

		// if(BusFeature.getProperty("ToPickupCount") > 0){

		//   htmlText += `
		//     <style>
		//       table {
		//         font-family: arial, sans-serif;
		//         border-collapse: collapse;
		//         width: 100%;
		//       }

		//       td, th {
		//         border: 1px solid #dddddd;
		//         text-align: left;
		//         padding: 8px;
		//       }

		//       tr:nth-child(even) {
		//         background-color: #dddddd;
		//       }
		//     </style>

		//     <div style="margin-top: 15px; padding: 15px; border: 2px solid black; border-radius: 15px; text-align: center;">
		//       <label>Students Assigned Route <span style="color: Red;">(NOT ON BUS)</span>:</label>
		//       <table>
		//         <tr>
		//           <th>Student ID</th>
		//           <th>Name</th>
		//         </tr>`;

		//   //
		//   // Add a row for each student in the list
		//   //
		//   var lstToPickUp = BusFeature.getProperty("lstStudentsToPickUp");
		//   for(var z = 0; z < lstToPickUp.length; z++){
		//     var next = lstToPickUp[z];

		//     htmlText +=  `
		//       <tr>
		//         <td>` + next.StudentID + `</td>
		//         <td>` + next.StudentName + `</td>
		//       </tr>
		//     `;
		//   }

		//   htmlText +=`
		//       </table>
		//     </div>
		//   `;
		// }

		return htmlText;
	}

	//
	// Student list after the images are loaded
	//
	BusStudentList(lstImages, BusFeature) {
		var htmlText: any = "";

		htmlText = this.GetBusPopupMain(BusFeature);

		//
		// List of Students
		//
		if (BusFeature.getProperty("StudentCount") > 0) {
			htmlText += `
        <style>
          table {
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
          }

          td, th {
            border: 1px solid #dddddd;
            text-align: left;
            padding: 8px;
          }

          tr:nth-child(even) {
            background-color: #dddddd;
          }
        </style>

        <div style="margin-top: 15px; padding: 15px; border: 2px solid black; border-radius: 15px; text-align: center;">
          <label>Students on Bus:</label>
          <table>
            <tr>
              <th>Photo</th>
              <th>Student ID</th>
              <th>Name</th>
            </tr>`;

			//
			// Add a row for each student in the list
			//
			var lstStudents = BusFeature.getProperty("lstStudentsOnBus");
			for (var z = 0; z < lstStudents.length; z++) {
				var next = lstStudents[z];

				var PersonPhoto = "";
				for (var i = 0; i < lstImages.length; i++) {
					var nextImage = lstImages[i];

					if (nextImage.PersonID == next.PersonID) {
						PersonPhoto = nextImage.PersonPhotoData;
					}
				}

				htmlText +=
					`
          <tr` +
					(next.AssignedRoute == false ? ` style="color: Red;"` : ``) +
					`>
            <td>
              <div style="border: 1px solid black; max-width: 200px; max-height: 200px;">
                <img style="max-width: 200px; max-height: 200px;" src="` +
					PersonPhoto +
					`">
              </div>
            </td>
            <td>` +
					next.StudentID +
					`</td>
            <td>` +
					next.StudentName +
					(next.AssignedRoute == false ? ` <span style="color: Red;">*</span>` : ``) +
					`</td>
          </tr>
        `;
			}

			htmlText += `
          </table>
        </div>
      `;
		}

		// if(BusFeature.getProperty("ToPickupCount") > 0){

		//   htmlText += `
		//     <style>
		//       table {
		//         font-family: arial, sans-serif;
		//         border-collapse: collapse;
		//         width: 100%;
		//       }

		//       td, th {
		//         border: 1px solid #dddddd;
		//         text-align: left;
		//         padding: 8px;
		//       }

		//       tr:nth-child(even) {
		//         background-color: #dddddd;
		//       }
		//     </style>

		//     <div style="margin-top: 15px; padding: 15px; border: 2px solid black; border-radius: 15px; text-align: center;">
		//       <label>Students Assigned Route <span style="color: Red;">(NOT ON BUS)</span>:</label>
		//       <table>
		//         <tr>
		//           <th>Student ID</th>
		//           <th>Name</th>
		//         </tr>`;

		//   //
		//   // Add a row for each student in the list
		//   //
		//   var lstToPickUp = BusFeature.getProperty("lstStudentsToPickUp");
		//   for(var z = 0; z < lstToPickUp.length; z++){
		//     var next = lstToPickUp[z];

		//     htmlText +=  `
		//       <tr>
		//         <td>` + next.StudentID + `</td>
		//         <td>` + next.StudentName + `</td>
		//       </tr>
		//     `;
		//   }

		//   htmlText +=`
		//       </table>
		//     </div>
		//   `;
		// }

		return htmlText;
	}

	GetStudentPopup(StudentFeature, infoWindow): string {
		this.LoadStudentPhoto(StudentFeature, infoWindow);

		return this.FinishGetStudentPopupImageLoading(StudentFeature);
	}

	LoadStudentPhoto(StudentFeature, infoWindow): string {
		var result = this.busService.PersonGetImage(StudentFeature.getProperty("Student_PersonID"));
		result.subscribe(
			(response) => {
				var img = response[0];

				infoWindow.setContent(this.FinishGetStudentPopup(StudentFeature, img));
			},
			(error) => {}
		);

		return "";
	}

	FinishGetStudentPopupImageLoading(StudentFeature) {
		var htmlText: any = "";

		htmlText += `
      <div style="text-align: center; width: fit-content; margin-left: auto; margin-right: auto;">
        <label style="margin-bottom: 10px;">...Image Loading</label>
      </div>
    `;

		return this.FinishGetPopupMain(StudentFeature, htmlText);
	}

	FinishGetStudentPopup(StudentFeature, img) {
		var htmlText: any = "";

		htmlText +=
			`
      <div style="text-align: center; width: fit-content; margin-left: auto; margin-right: auto;">
        <div style="border: 1px solid black; max-width: 200px; max-height: 200px; margin-bottom: 10px;">
          <img style="max-width: 200px; max-height: 200px;" src="` +
			img +
			`">
        </div>
      </div>
    `;

		return this.FinishGetPopupMain(StudentFeature, htmlText);
	}

	FinishGetPopupMain(StudentFeature, htmlText) {
		//
		// Main Info
		//
		htmlText +=
			`
      <div style="display: grid; grid-template-columns: auto auto; grid-column-gap: 15px; grid-row-gap: 15px; padding: 15px; border: 2px solid black; border-radius: 15px; align-items: center;">
      
        <h4 style="grid-column: 1 / 3; text-align: center; margin-top: -5px; margin-bottom: -5px;">Student:</h4>

        <label style="margin: 0px;">Student ID:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("StudentID") +
			`</p>

        <label style="margin: 0px;">Student Name:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("StudentName") +
			`</p>
        
        <label style="margin: 0px;">Bus Number:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("BusNbr") +
			`</p>

        <label style="margin: 0px;">Bus Description:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("BusDesc") +
			`</p>

        <label style="margin: 0px;">Driver:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("DriverName") +
			`</p>

        <label style="margin: 0px;">Route Description:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("BusRouteDesc") +
			`</p>

        <label style="margin: 0px;">Route Type:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("BusRouteTypeDesc") +
			`</p>

        <label style="margin: 0px;">Entry/Exit Type:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("EntryTypeDesc") +
			`</p>

        <label style="margin: 0px;">Scan Time:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("c_dateDesc") +
			`</p>`;

		htmlText += `<label style="margin: 0px;">Scheduled Rider:</label>`;

		if (StudentFeature.getProperty("AssignedRoute") == true) {
			htmlText += `<p style="margin: 0px; color: Blue;">Yes</p>`;
		} else {
			htmlText += `<p style="margin: 0px; color: Red;">No (added manually)</p>`;
		}

		htmlText +=
			`
          <label style="margin: 0px;">Scan Type:</label>
          <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("ScanTypeDesc") +
			`</p>`;

		htmlText += `</div>`;

		return htmlText;
	}

	GetGeoFencePopup(GeoFenceInfo) {
		var htmlText: any = "";

		htmlText +=
			`
      <div style="display: grid; grid-template-columns: auto auto; grid-column-gap: 15px; grid-row-gap: 15px; padding: 15px; border: 2px solid black; border-radius: 15px; align-items: center;">
      
        <h4 style="grid-column: 1 / 3; text-align: center; margin-top: -5px; margin-bottom: -5px;">Geo Fence:</h4>

        <label style="margin: 0px;">Description:</label>
        <p style="margin: 0px; color: blue;">` +
			GeoFenceInfo.getProperty("GeoFenceDesc") +
			`</p>

        <label style="margin: 0px;">Used By:</label>
        <p style="margin: 0px; color: blue;">` +
			GeoFenceInfo.getProperty("BusDesc") +
			`</p>

        <label style="margin: 0px;">Trigger Type Code:</label>
        <p style="margin: 0px; color: blue;">` +
			GeoFenceInfo.getProperty("GeofenceTriggerTypeCD") +
			`</p>

        <label style="margin: 0px;">Trigger Type Description:</label>
        <p style="margin: 0px; color: blue;">` +
			GeoFenceInfo.getProperty("GeofenceTriggerTypeDesc") +
			`</p>

        <label style="margin: 0px;">Severity:</label>
        <p style="margin: 0px; color: blue;">` +
			GeoFenceInfo.getProperty("SeverityDesc") +
			`</p>

        <label style="margin: 0px;">Comments:</label>
        <p style="margin: 0px; color: blue;">` +
			GeoFenceInfo.getProperty("AlertComments") +
			`</p>

        <label style="margin: 0px;">Active:</label>
        <p style="margin: 0px; color: blue;">` +
			GeoFenceInfo.getProperty("ActiveDesc") +
			`</p>

      </div>
    `;

		return htmlText;
	}

	GetKnownLocationPopup(LocationInfo) {
		var htmlText: any = "";

		//
		// Main Info
		//
		htmlText +=
			`

      <div style="display: grid; grid-template-columns: auto auto; grid-column-gap: 15px; grid-row-gap: 15px; padding: 15px; border: 2px solid black; border-radius: 15px; align-items: center;">
      
        <h4 style="grid-column: 1 / 3; text-align: center; margin-top: -5px; margin-bottom: -5px;">Known Location:</h4>

        <label style="margin: 0px;">Bus Number:</label>
        <p style="margin: 0px; color: blue;">` +
			LocationInfo.getProperty("BusNbr") +
			`</p>

        <label style="margin: 0px;">Bus Description:</label>
        <p style="margin: 0px; color: blue;">` +
			LocationInfo.getProperty("BusDesc") +
			`</p>

        <label style="margin: 0px;">Driver:</label>
        <p style="margin: 0px; color: blue;">` +
			LocationInfo.getProperty("DriverName") +
			`</p>

        <label style="margin: 0px;">Current Route:</label>
        <p style="margin: 0px; color: blue;">` +
			LocationInfo.getProperty("BusRouteDesc") +
			`</p>
        
        <label style="margin: 0px;">Route Type:</label>
        <p style="margin: 0px; color: blue;">` +
			LocationInfo.getProperty("BusRouteTypeDesc") +
			`</p>

        <label style="margin: 0px;">Speed:</label>
        <p style="margin: 0px; color: blue;">` +
			LocationInfo.getProperty("SpeedMph") +
			`</p>
        
        <label style="margin: 0px;">Date/Time:</label>
        <p style="margin: 0px; color: blue;">` +
			LocationInfo.getProperty("c_dateDesc") +
			`</p>

        <label style="margin: 0px;">Latitude:</label>
        <p style="margin: 0px; color: blue;">` +
			LocationInfo.getProperty("Lat") +
			`</p>

        <label style="margin: 0px;">Longitude:</label>
        <p style="margin: 0px; color: blue;">` +
			LocationInfo.getProperty("Long") +
			`</p>

      </div>
    `;

		return htmlText;
	}

	//#endregion

	//#region Spiderfy Students

	SpiderfyUpdateOverlapList(event) {
		//////////////////////////////////////////////////////////////////
		//#region Get list of overlapping features (on Data Layer)
		//////////////////////////////////////////////////////////////////

		var scale = 1 << this.mapRef.map.getZoom();

		var WorldCoordinate = this.project(
			new google.maps.LatLng({
				lat: event.feature.getProperty("Lat"),
				lng: event.feature.getProperty("Long"),
			})
		);
		var PixelCoordinate = new google.maps.Point(Math.floor(WorldCoordinate.x * scale), Math.floor(WorldCoordinate.y * scale));

		this.lstOverlaps = [];

		this.mapRef.map.data.forEach((element) => {
			if (element.getProperty("Type") == "Student") {
				var NextWorldCoordinate = this.project(
					new google.maps.LatLng({
						lat: element.getProperty("Lat"),
						lng: element.getProperty("Long"),
					})
				);
				var NextPixelCoordinate = new google.maps.Point(Math.floor(NextWorldCoordinate.x * scale), Math.floor(NextWorldCoordinate.y * scale));

				var DistanceSq = Math.pow(NextPixelCoordinate.x - PixelCoordinate.x, 2) + Math.pow(NextPixelCoordinate.y - PixelCoordinate.y, 2);

				if (
					DistanceSq < Math.pow(this.Tolerance, 2) &&
					element.getProperty("BusStudentRideTxnID") != event.feature.getProperty("BusStudentRideTxnID")
				) {
					var nextEntry = element;
					// {
					//   Feature: element,
					//   DistanceSq: DistanceSq
					// };

					this.lstOverlaps = [...this.lstOverlaps, nextEntry];
				}
			}
		});

		//
		// Sort by distance ascending
		//
		// this.lstOverlaps.sort((a, b) => a.DistanceSq - b.DistanceSq);
		// for(var z = 0; z < this.lstOverlaps.length; z++){
		//   var next = this.lstOverlaps[z];
		//   this.lstOverlaps[z] = next.Feature;
		// }

		//#endregion
		//////////////////////////////////////////////////////////////////

		return;
	}

	StudentSpiderfy(event) {
		this.SpiderfyBusStudentRideTxnID = event.feature.getProperty("BusStudentRideTxnID");

		//////////////////////////////////////////////////////////////////
		//#region Move overlapping points out of the way
		//////////////////////////////////////////////////////////////////

		for (var z = 0; z < this.lstOverlaps.length; z++) {
			var next = this.lstOverlaps[z];

			next.setGeometry(this.SpiderGeometry(event.feature, next, z));
		}

		//#endregion
		//////////////////////////////////////////////////////////////////

		this.overlays = [...this.overlays, ...this.lstSpiderOverlays];
	}

	//
	// Return a google.maps.Data.Point for spiderfying
	//
	SpiderGeometry(Origin, feature, Index) {
		//
		// NEW, Circle from origin
		//

		var Layer: any = Math.floor(Index / this.SpiderMaxLegs);

		var CurrentZoom: any = this.mapRef.map.getZoom();

		var M_PX = 591657550.5 / Math.pow(2, CurrentZoom);
		var Length = (Layer + 1) * this.ZoomCoefficient * M_PX;

		var NewLat: any = Origin.getProperty("Lat") + Length * Math.cos((Index * 2 * Math.PI) / this.SpiderMaxLegs);
		var NewLong: any = Origin.getProperty("Long") + Length * Math.sin((Index * 2 * Math.PI) / this.SpiderMaxLegs);

		//
		// NEW
		//
		// Make web connecting points in spiral
		//
		if (this.lstSpiderOverlays.length > 0) {
			var lastPath = this.lstSpiderOverlays[this.lstSpiderOverlays.length - 1].getPath();
			var lastPoint = lastPath.getAt(1);

			this.lstSpiderOverlays.push(
				new google.maps.Polyline({
					path: [
						{ lat: lastPoint.lat(), lng: lastPoint.lng() },
						{ lat: NewLat, lng: NewLong },
					],
					strokeColor: "#FF0000", //Index % 2 == 0 ? "#FF0000" : "#0000FF",
					strokeOpacity: 1.0,
					strokeWeight: 2,
				})
			);
		} else {
			this.lstSpiderOverlays.push(
				new google.maps.Polyline({
					path: [
						{
							lat: Origin.getProperty("Lat"),
							lng: Origin.getProperty("Long"),
						},
						{ lat: NewLat, lng: NewLong },
					],
					strokeColor: Index % 2 == 0 ? "#FF0000" : "#0000FF",
					strokeOpacity: 1.0,
					strokeWeight: 2,
				})
			);
		}

		return new google.maps.Data.Point(
			new google.maps.LatLng({
				lat: NewLat,
				lng: NewLong,
			})
		);
	}

	StudentUnSpiderfy() {
		this.SpiderfyBusStudentRideTxnID = -1;

		for (var z = 0; z < this.lstOverlaps.length; z++) {
			var next = this.lstOverlaps[z];

			next.setGeometry(
				new google.maps.Data.Point(
					new google.maps.LatLng({
						lat: next.getProperty("Lat"),
						lng: next.getProperty("Long"),
					})
				)
			);
		}

		this.lstOverlaps = [];

		this.overlays = this.overlays.filter((overlay) => this.lstSpiderOverlays.indexOf(overlay) == -1);
		this.lstSpiderOverlays = []; //Delete lines that show the position changed (NOTE: DOESN'T AFFECT ACTUAL OVERLAYS, they're data layer objects)
	}

	// The mapping between latitude, longitude and pixels is defined by the web
	// mercator projection.
	project(latLng: google.maps.LatLng) {
		let siny = Math.sin((latLng.lat() * Math.PI) / 180);

		// Truncating to 0.9999 effectively limits latitude to 89.189. This is
		// about a third of a tile past the edge of the world tile.
		siny = Math.min(Math.max(siny, -0.9999), 0.9999);

		return new google.maps.Point(256 * (0.5 + latLng.lng() / 360), 256 * (0.5 - Math.log((1 + siny) / (1 - siny)) / (4 * Math.PI)));
	}

	SelectStudent(event) {
		/////////////////////////////////////////////////////////////////////////////////////////////////////
		// Select or deselect Bus
		/////////////////////////////////////////////////////////////////////////////////////////////////////

		var tempSelected = event.feature.getProperty("Selected");

		var NewSelected = true;
		if (tempSelected == true) {
			NewSelected = false;
		}

		event.feature.setProperty("Selected", NewSelected);

		// var Student_PersonID = event.feature.getProperty("Student_PersonID");

		// if(NewSelected == true){
		//   for(var z = 0; z < this.lstStudentPositions.length; z++){
		//     var next = this.lstStudentPositions[z];

		//     if(next.Student_PersonID == Student_PersonID){
		//       this.lstSelectedStudents = [...this.lstSelectedStudents, next];
		//       break;
		//     }
		//   }

		//   // this.mapRef.map.setCenter( { lat: event.feature.getProperty("Lat"), lng: event.feature.getProperty("Long") } );

		// }
		// else{
		//   this.lstSelectedStudents = this.lstSelectedStudents.filter(student =>  student.Student_PersonID != Student_PersonID);
		// }

		/////////////////////////////////////////////////////////////////////////////////////////////////////
	}

	//#endregion

	///////////////////////////////////////////////////////////////////////////
}
